import {Pipe, PipeTransform} from '@angular/core';
import * as removeAccents from 'remove-accents';

@Pipe({
    name: 'modalFilter'
})
export class ModalFilterPipe implements PipeTransform {
    transform(value: any, filtroCodigo?: string, filtroNome?: string, filtroNomeResponsavel?: string, filtroEmailResponsavel?: string): any {
        let resultFilter = value;
        if (!filtroCodigo && !filtroNome && !filtroNomeResponsavel && !filtroEmailResponsavel) {
            return resultFilter;
        } else {
            if (filtroCodigo) {
                resultFilter = resultFilter.filter(s => removeAccents(s.codigo).toLocaleString().toLowerCase().includes(removeAccents(filtroCodigo).toLowerCase()));
            }

            if (filtroNome || !filtroNome) {
                resultFilter = resultFilter.filter(s => removeAccents(s.nome).toLocaleString().toLowerCase().includes(removeAccents(filtroNome).toLowerCase()));
            }

            if (filtroNomeResponsavel) {
                resultFilter = resultFilter.filter(s => removeAccents(s.nomeResponsavel).toLocaleString().toLowerCase().includes(removeAccents(filtroNomeResponsavel).toLowerCase()));
            }

            if (filtroEmailResponsavel) {
                resultFilter = resultFilter.filter(s => removeAccents(s.emailResponsavel).toLocaleString().toLowerCase().includes(removeAccents(filtroEmailResponsavel).toLowerCase()));
            }
        }
        return resultFilter;
    }
}
